import * as React from 'react';
import classnames from 'classnames';
import CheckIcon from '../../../images/svg/icons8-checkmark-solid';

// eslint-disable-next-line no-unused-vars
interface IProps<T> {
    name?: string | JSX.Element;
    isSelected: boolean;
    isDisabled?: boolean;
    isGroup?: boolean;
    isInsideGroup?: boolean;
    onClick?: () => void;
    onCheckboxClick?: () => void;
    isCheckboxInLeft?: boolean;
    hoverLabel?: string;
    isHidden?: boolean;
}

const MultiSelectOption = <T, >(props: IProps<T>) => {
    const { onClick, isDisabled, isSelected, isGroup, isInsideGroup, name, onCheckboxClick, isCheckboxInLeft, hoverLabel, isHidden } = props;

    const handleClick = () => {
        if (!isDisabled && onClick) {
            onClick();
        }

    };

    const handleCheckboxClick = e => {
        if (!isDisabled && onCheckboxClick) {
            e.stopPropagation();
            onCheckboxClick();
        }
    };

    return (
        <div className={classnames('multi-select-list__option', {
            'multi-select-list__option--selected': isSelected,
            'multi-select-list__option--disabled': isDisabled || isHidden,
            'multi-select-list__option--checkbox-in-left': isCheckboxInLeft,
            'multi-select-list__option--hidden': isHidden
        })} onClick={handleClick}>
            { !!name &&
                <div className={classnames('multi-select-list__option-text', {
                        'multi-select-list__option-text--group': isGroup,
                        'multi-select-list__option-text--within-group': isInsideGroup,
                    })}
                    title={hoverLabel}>
                    {name}
                </div>
            }
            <span className='multi-select-list__checkbox' onClick={e => {
                handleCheckboxClick(e);
            }}>
                <CheckIcon />
            </span>
        </div>
    );
};

export { MultiSelectOption };